import React from 'react';
import { Widget } from '../types/widget';
import { WidgetCard } from './WidgetCard';

interface ChartSectionProps {
    widgets: Widget[];
    onDelete: (widget: Widget) => void;
    onAskMore?: (contextQuery: string, contextData?: any) => void;
    renderWidget?: (widget: Widget, index: number) => React.ReactNode;
}

const ChartSection: React.FC<ChartSectionProps> = ({ 
    widgets, 
    onDelete, 
    onAskMore, 
    renderWidget 
}) => {
    if (widgets.length === 0) {
        return null;
    }

    return (
        <div>
            {/* Responsive auto-fit grid for charts with optimized height */}
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 mb-8">
                {widgets.map((widget, index) => 
                    renderWidget ? (
                        renderWidget(widget, index)
                    ) : (
                        <WidgetCard
                            key={widget.id}
                            widget={widget}
                            onDelete={onDelete}
                            onAskMore={onAskMore}
                        />
                    )
                )}
            </div>
        </div>
    );
};

export default ChartSection;